// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
class _TimeSpan {
    // TODO. Rename. Refactor.
    FromMinutes(minutes) {
        return new Date(TimeSpanPeriods.MillisPerMinute * minutes);
    }
    FromHours(hours) {
        return new Date(TimeSpanPeriods.MillisPerHour * hours);
    }
    // TODO. Rename. Refactor.
    FromDays(days) {
        return new Date(TimeSpanPeriods.MillisPerDay * days);
    }
    // TODO. Rename. Refactor.
    FromUTCTimeOfDay(dt) {
        const millis = dt.getUTCHours() * TimeSpanPeriods.MillisPerHour +
            dt.getUTCMinutes() * TimeSpanPeriods.MillisPerMinute +
            dt.getUTCSeconds() * TimeSpanPeriods.MillisPerSecond +
            dt.getUTCMilliseconds();
        return new Date(millis);
    }
    // TODO. Rename. Refactor.
    toSeconds(millis) {
        return Math.round(millis / TimeSpanPeriods.MillisPerSecond);
    }
    ticksToTimeSpanObject(ticks) {
        const days = Math.floor(ticks / TimeSpanPeriods.TicksPerDay);
        ticks -= days * TimeSpanPeriods.TicksPerDay;
        const hours = Math.floor(ticks / TimeSpanPeriods.TicksPerHour);
        ticks -= hours * TimeSpanPeriods.TicksPerHour;
        const minutes = Math.floor(ticks / TimeSpanPeriods.TicksPerMinute);
        ticks -= minutes * TimeSpanPeriods.TicksPerMinute;
        const seconds = Math.floor(ticks / TimeSpanPeriods.TicksPerSecond);
        return {
            Days: days,
            Hours: hours,
            Minutes: minutes,
            Seconds: seconds
        };
    }
    ToTimeSpanString(span, format) {
        let formatted = '';
        format = format || TimeSpanFormat.All;
        switch (format) {
            case TimeSpanFormat.All:
                if (span.Days > 0) {
                    formatted += span.Days + TimeSpanPeriodString.Day;
                }
                if (span.Hours > 0) {
                    formatted += (formatted ? ' ' : '') + span.Hours + TimeSpanPeriodString.Hour;
                }
                if (span.Minutes > 0) {
                    formatted += (formatted ? ' ' : '') + span.Minutes + TimeSpanPeriodString.Month;
                }
                if (span.Seconds > 0) {
                    formatted += (formatted ? ' ' : '') + span.Seconds + TimeSpanPeriodString.Second;
                }
                break;
            case TimeSpanFormat.YearDay:
                formatted =
                    (span.Days > 0 ? Math.floor(span.Days / 365) + TimeSpanPeriodString.Year : '') +
                        (span.Days > 0 ? (span.Days % 365) + TimeSpanPeriodString.Day : '');
                break;
            case TimeSpanFormat.DayHour:
                formatted =
                    (span.Days > 0 ? span.Days + TimeSpanPeriodString.Day + ' ' : '') +
                        (span.Hours > 0 ? span.Hours + TimeSpanPeriodString.Hour : '');
                break;
            case TimeSpanFormat.HourMinute:
                formatted =
                    (span.Hours < 10 ? '0' : '') + span.Hours + ':' + (span.Minutes < 10 ? '0' : '') + span.Minutes;
                break;
            case TimeSpanFormat.MinuteSecond:
                formatted =
                    (span.Minutes < 10 ? '0' : '') + span.Minutes + ':' + (span.Seconds < 10 ? '0' : '') + span.Seconds;
                break;
            case TimeSpanFormat.HourMinuteSecond:
                const hours = span.Hours + (span.Days > 0 ? span.Days * 24 : 0);
                formatted =
                    (hours < 10 ? '0' : '') +
                        hours +
                        ':' +
                        (span.Minutes < 10 ? '0' : '') +
                        span.Minutes +
                        ':' +
                        (span.Seconds < 10 ? '0' : '') +
                        span.Seconds;
                break;
        }
        return formatted;
    }
    MomentDurationToTimeSpan(md) {
        let milliseconds = md.asMilliseconds();
        let seconds = Math.floor(milliseconds / 1000);
        milliseconds = milliseconds % 1000;
        let minutes = Math.floor(seconds / 60);
        seconds = seconds % 60;
        let hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
        const days = Math.floor(hours / 24);
        hours = hours % 24;
        return {
            Milliseconds: milliseconds,
            Seconds: seconds,
            Minutes: minutes,
            Hours: hours,
            Days: days
        };
    }
    FromMinToMs(minutes) {
        return minutes * 60 * 1000;
    }
}
export const TimeSpan = new _TimeSpan();
export var TimeSpanPeriods;
(function (TimeSpanPeriods) {
    TimeSpanPeriods[TimeSpanPeriods["TicksPerDay"] = 86400000] = "TicksPerDay";
    TimeSpanPeriods[TimeSpanPeriods["TicksPerHour"] = 3600000] = "TicksPerHour";
    TimeSpanPeriods[TimeSpanPeriods["TicksPerMillisecond"] = 1] = "TicksPerMillisecond";
    TimeSpanPeriods[TimeSpanPeriods["TicksPerSecond"] = 1000] = "TicksPerSecond";
    TimeSpanPeriods[TimeSpanPeriods["TicksPerMinute"] = 60000] = "TicksPerMinute";
    TimeSpanPeriods[TimeSpanPeriods["MillisPerSecond"] = 1000] = "MillisPerSecond";
    TimeSpanPeriods[TimeSpanPeriods["MillisPerMinute"] = 60000] = "MillisPerMinute";
    TimeSpanPeriods[TimeSpanPeriods["MillisPerHour"] = 3600000] = "MillisPerHour";
    TimeSpanPeriods[TimeSpanPeriods["MillisPerDay"] = 86400000] = "MillisPerDay";
})(TimeSpanPeriods || (TimeSpanPeriods = {}));
export var TimeSpanFormat;
(function (TimeSpanFormat) {
    TimeSpanFormat[TimeSpanFormat["All"] = 0] = "All";
    TimeSpanFormat[TimeSpanFormat["YearDay"] = 1] = "YearDay";
    TimeSpanFormat[TimeSpanFormat["DayHour"] = 2] = "DayHour";
    TimeSpanFormat[TimeSpanFormat["HourMinute"] = 3] = "HourMinute";
    TimeSpanFormat[TimeSpanFormat["MinuteSecond"] = 4] = "MinuteSecond";
    TimeSpanFormat[TimeSpanFormat["MilisecondSecondMinute"] = 5] = "MilisecondSecondMinute";
    TimeSpanFormat[TimeSpanFormat["AdvancedAllTime"] = 6] = "AdvancedAllTime";
    TimeSpanFormat[TimeSpanFormat["HourMinuteSecond"] = 7] = "HourMinuteSecond";
})(TimeSpanFormat || (TimeSpanFormat = {}));
var TimeSpanPeriodString;
(function (TimeSpanPeriodString) {
    TimeSpanPeriodString["Year"] = "y";
    TimeSpanPeriodString["Day"] = "d";
    TimeSpanPeriodString["Hour"] = "h";
    TimeSpanPeriodString["Month"] = "m";
    TimeSpanPeriodString["Minute"] = "m";
    TimeSpanPeriodString["Second"] = "s";
})(TimeSpanPeriodString || (TimeSpanPeriodString = {}));
